import { filterOptions } from '@/utils/query-base'

const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'customer1': {
    title: '老商家编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '老商家编码'
    }
  },
  'cust_name1': {
    title: '老商家名称',
    type: 'input',
    equation: cusname,
    width: 200
  },
  'customer2': {
    title: '新商家编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '新商家编码'
    }
  },
  'cust_name2': {
    title: '新商家名称',
    type: 'input',
    equation: cusname,
    width: 200
  },
  'sal_center': {
    describe: true,
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  },
  'region': {
    describe: true,
    title: '省份',
    type: 'select',
    equation: be,
    dictionary: 'region'
  },
  'city': {
    describe: true,
    title: '城市',
    type: 'select',
    equation: city,
    dictionary: 'city'
  },
  'gjahr': {
    title: '年度',
    type: 'year',
    equation: city
  },
  'plan_type': {
    describe: true,
    title: '计划类型',
    type: 'select',
    equation: city,
    dictionary: 'A0002',
    width: 180
  },
  'wlybrand': {
    describe: true,
    title: '存货分类',
    type: 'select',
    equation: all,
    dictionary: 'A0019',
    width: 180
  },
  'shift_datum': {
    title: '转移日期',
    type: 'date',
    equation: all
  },
  'shift_qty01': {
    title: '1月份转移计划量(件)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_amt01': {
    title: '1月份转移计划额(万元)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_qty02': {
    title: '2月份转移计划量(件)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_amt02': {
    title: '2月份转移计划额(万元)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_qty03': {
    title: '3月份转移计划量(件)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_amt03': {
    title: '3月份转移计划额(万元)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_qty04': {
    title: '4月份转移计划量(件)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_amt04': {
    title: '4月份转移计划额(万元)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_qty05': {
    title: '5月份转移计划量(件)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_amt05': {
    title: '5月份转移计划额(万元)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_qty06': {
    title: '6月份转移计划量(件)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_amt06': {
    title: '6月份转移计划额(万元)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_qty07': {
    title: '7月份转移计划量(件)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_amt07': {
    title: '7月份转移计划额(万元)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_qty08': {
    title: '8月份转移计划量(件)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_amt08': {
    title: '8月份转移计划额(万元)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_qty09': {
    title: '9月份转移计划量(件)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_amt09': {
    title: '9月份转移计划额(万元)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_qty10': {
    title: '10月份转移计划量(件)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_amt10': {
    title: '10月份转移计划额(万元)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_qty11': {
    title: '11月份转移计划量(件)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_amt11': {
    title: '11月份转移计划额(万元)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_qty112': {
    title: '12月份转移计划量(件)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'shift_amt12': {
    title: '12月份转移计划额(万元)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/annualSalesPlanTransferReportForms.js